import { render } from "./SurveyFileItem.vue?vue&type=template&id=4d9cd24d"
import script from "./SurveyFileItem.vue?vue&type=script&lang=js"
export * from "./SurveyFileItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__